<template>
  <div>
    <student-loader @initialized="initialized = true" />
    <router-view v-if="initialized" />
  </div>
</template>

<script>
import StudentLoader from 'components/student-loader';

export default {
  components: {
    StudentLoader,
  },
  data() {
    return {
      initialized: false,
    };
  },
};
</script>
